import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { VscAccount } from 'react-icons/vsc'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import i18n from 'i18next'
import cookies from 'js-cookie'
import WebLogo from '../webLogo/WebLogo'
import SearchModal from '../SearchModal/SearchModal'
import gnasLogo from '../../../src/assets/images/gnasLogo.jpg'
import { shallowEqual, useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { getUser } from '../../entity/user/model/slice/userSlice'

const NavbarLinks = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(state => state?.user?.data, shallowEqual)

  useEffect(() => {
    dispatch(getUser(localStorage.getItem('accessToken')))
  }, [dispatch])

  const navList = [
    {
      name: t('Navbar.home'),
      link: '/',
    },
    {
      name: t('Navbar.aboutUs'),
      link: '/about',
    },
    {
      name: t('Navbar.index'),
      link: '/index',
    },
    {
      name: t('Navbar.guide'),
      link: '/guide',
    },
    {
      name: t('Navbar.submit'),
      link: '/submit',
    },
    {
      name: t('Navbar.issue'),
      link: '/volumes',
    },
    {
      name: t('Navbar.archive'),
      link: '/archive',
    },
    {
      name: t('Navbar.contact'),
      link: '/contact',
    },
  ]

  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'ka',
      name: 'ქართული',
      country_code: 'ge',
    },
  ]

  const currentLangCode = cookies.get('i18next') || 'en'
  let currentLanguage = languages.find(l => l.code === currentLangCode)

  const [lang, setLang] = useState(currentLanguage)

  const logout = () => {
    localStorage.removeItem('accessToken')
    window.location.reload()
  }

  const renderProfileButton = () => {
    const myProfileButton = () => {
      return (
        <div className='user-dropdown-wrapper'>
          <VscAccount style={{ color: 'rgb(0, 35, 54)' }} /> <span>{user?.username}</span>
        </div>
      )
    }

    if (user?.id) {
      return (
        <ul className='Nav-list content'>
          <li>
            <span>
              <DropdownButton
                className='drop-p'
                menualign='left'
                id='dropdown-basic-button'
                title={myProfileButton()}>
                {user?.role === 'admin' && (
                  <Dropdown.Item>
                    <Link to='/admin/dashboard'>{t('Navbar.adminPanel')}</Link>
                  </Dropdown.Item>
                )}
                {user?.role === 'user' && (
                  <Dropdown.Item
                  // onClick={() => setOpen(!open)}
                  >
                    <Link to='/user/myprofile'>{t('Navbar.profile')}</Link>
                  </Dropdown.Item>
                )}
                <div
                  className='logout-span'
                  // onClick={() => setOpen(!open)}
                >
                  <Dropdown.Item onClick={logout}>{t('Navbar.logout')}</Dropdown.Item>
                </div>
              </DropdownButton>
            </span>
          </li>
        </ul>
      )
    } else {
      return (
        <li>
          <Link
            to='/login'
            className='auth'
            // onClick={() => setOpen(!open)}
          >
            <VscAccount style={{ color: 'rgb(0, 35, 54)' }} /> {t('Navbar.authButton')}
          </Link>
        </li>
      )
    }
  }

  return (
    <div className='navbar-links Nav-bar'>
      <WebLogo />
      <div className='gnasLogo_main'>
        <img src={gnasLogo} alt='gnas' />
      </div>
      <ul className='Nav-list'>
        {navList.map((e, i) => (
          <li key={i}>
            <Link
              className={e.link === window.location.pathname ? 'active-background' : null}
              to={e.link}
              // onClick={() => setOpen(!open)}
            >
              <span>{e.name}</span>
            </Link>
          </li>
        ))}
      </ul>
      <SearchModal />
      <ul className='Nav-login'>
        {renderProfileButton()}
        <ul className='Nav-list content'>
          <li>
            <span>
              <Dropdown className='drop-p' menualign='left' id='dropdown-basic-button'>
                <DropdownButton
                  className=' drop-p'
                  menualign='left'
                  id='dropdown-basic-button'
                  title={lang.name}>
                  {languages.map(({ code, name, country_code }) => (
                    <Dropdown.Item
                      key={country_code}
                      onClick={() => {
                        i18n.changeLanguage(code)
                        setLang(languages.find(l => l.code === code))
                      }}>
                      <span className={`flag-icon flag-icon-${country_code} mx-2`}></span>
                      {name}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Dropdown>
            </span>
          </li>
        </ul>
      </ul>
    </div>
  )
}

export default NavbarLinks
